const record = (value: unknown): value is Record<string, unknown> =>
    value !== null && typeof value === 'object' && !Array.isArray(value);

export const positiveRouteIdentity = (value: unknown): number | null => {
    if (typeof value !== 'number' && (typeof value !== 'string' || !/^\d+$/.test(value))) return null;
    const id = Number(value);
    return Number.isSafeInteger(id) && id > 0 ? id : null;
};

// ProvidersInfo embeds HotelDTO; both bare and ApiResponse-wrapped summaries use hotel.id.
export const matchesProviderHotelScope = (response: unknown, hotelId: number): boolean => {
    if (!record(response) || response.error != null) return false;
    const info = Object.prototype.hasOwnProperty.call(response, 'data') ? response.data : response;
    if (!record(info) || !record(info.hotel)) return false;
    const identity = positiveRouteIdentity(info.hotel.id);
    return identity !== null && identity === hotelId;
};
